import React, { useState,useEffect, useRef, createRef } from 'react';
import Scanner from '../../plugins/Scanner';
import { Modal , Button, Form} from 'react-bootstrap';

const App = (props) => {
    const [scanning, setScanning] = useState(false);
    // const [manualEntry, setManualEntry] = useState('');
    const [barcode, setBarcode] = useState(null);
    const [barcodeMsg, setBarcodeMsg] = useState('Please enter barcode')
    const [displayError, setDisplayError] = useState(false)
    const scannerRef = useRef(null);
    const barcodeValueInput = createRef(null);

    const validations = (value) =>{
        value = value.toUpperCase()
        if(!value){
            setBarcodeMsg('Please enter barcode')
            setDisplayError(true)
            return true
        } else if(!((value[0] == 'M' && value[1] == 'B') || (value[0] == 'M' && value[1] == 'D'))){
            setBarcodeMsg('Barcode should start with MB')
            setDisplayError(true)
            return true
        }  else if(value.match(/\W/)){
            setBarcodeMsg('Barcode should not contain special characters')
            setDisplayError(true)
            return true
        }
    }

    const fetchResult = (result) => {
        console.log("barcode",result)
        const check = validations(result)
        if(check){
            console.log(barcodeMsg)
            return false
        }
        if(result){
            props.dataparenttochild['barcode'] = result;
            props.parentCallback(props.dataparenttochild);
    
            setBarcode(result)
            setScanning(false)
            props.onHide();
        }   
    }   

    window.addEventListener('setBarcodeEvent', (ev) => {
        console.log("event triggered",ev.detail);
        barcodeValueInput.current.value = ev.detail;
        ev.stopImmediatePropagation();
    });


    // useEffect(() => {
    //     console.log("manualEntry --> use effect",manualEntry);
    // }, [manualEntry]);



    const checkBarCode = () =>{
        if(typeof android !== "undefined" && android !== null) {
            console.log("Checking Bar code from app");
             android.startBarcodeScanner();
        } else {
            console.log("normal Bar code")
            setScanning(!scanning);
        }
    }

    return (
        <div>
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                    Bar Code Scanner
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{height:"400px",padding:'5px'}}>
                    <div ref={scannerRef} className={(scanning ? 'scanning' : 'no-scanning') + ' display-center position-relative'}>
                        {/* <video style={{ width: window.innerWidth, height: 480, border: '3px solid orange' }}/> */}
                        {scanning ? <canvas className="drawingBuffer" style={{
                            position: 'absolute',
                            top:0,
                            border: '3px solid #ccc',
                        }} width="320" height="380" /> : null}
                        {scanning ? <Scanner scannerRef={scannerRef} onDetected={(result) => fetchResult(result)} /> : 
                            <div className="mt-5 pt-3">
                                <Form onSubmit={(e)=>{
                                    e.preventDefault();
                                    fetchResult(barcodeValueInput.current.value)
                                }}>
                                    <Form.Group controlId="formGroupEmail">
                                    <Form.Label>Enter Bar code</Form.Label>
                                    <Form.Control ref={barcodeValueInput} type="text" name='barcode' placeholder="Enter code"/>
                                    {displayError ? <Form.Label style={{
                                        color: 'red',
                                        fontSize: '12px'
                                    }}>{barcodeMsg}</Form.Label> : null}
                                    </Form.Group>
                                    <Button variant="primary" type="submit"  className="text-align-center w-100"> Save </Button>
                                    <hr/>
                                    <div className="text-center">
                                    <i className="fa fa-qrcode font-size-lg" onClick={() => checkBarCode() }>
                                        <span className="base-color p-l-10 font-family-default">
                                        Scan
                                        </span>
                                    </i>
                                    </div>
                                    
                                </Form>
                          </div>
                        }
                    </div>
                </Modal.Body>
                {scanning && 
                    <Modal.Footer>
                        <Button variant="link" block onClick={() => setScanning(!scanning) } >Enter code manually</Button>
                    </Modal.Footer>}
            </Modal>
        </div>
    );
};

export default App;
